module.exports = __webpack_public_path__ + "img/icon-03-1.e8b028ba.png";